import React from "react";

//CSS
import "./ShowcaseBlock.css";

//Animations
import { motion } from "framer-motion";
import {
  slideInOnScrollLeft,
  slideInOnScrollRight,
} from "../Other Components/animations";

export default function ShowcaseBlock({
  side = "left",
  eyebrow,
  title,
  text,
  imgSrc,
  bullets = [],
}) {
  const finalSide = side === "right" ? "right" : "left";

  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.25 }}
      variants={
        finalSide === "left"
          ? slideInOnScrollLeft("60px", 0.6)
          : slideInOnScrollRight("60px", 0.6)
      }
      className={"showcase-block " + finalSide}
    >
      <div className="showcase-block-media">
        <motion.div
          className="browser-frame"
          whileHover={{ y: -6 }}
          transition={{ duration: 0.25, ease: "easeOut" }}
        >
          <div className="browser-frame-chrome">
            <span className="browser-dot dot-red"></span>
            <span className="browser-dot dot-yellow"></span>
            <span className="browser-dot dot-green"></span>
          </div>
          <div className="browser-frame-body">
            <img src={imgSrc} alt={title} loading="lazy" />
          </div>
        </motion.div>
        <div className="showcase-glow" aria-hidden="true"></div>
      </div>

      <div className="showcase-block-text">
        {eyebrow && <span className="showcase-eyebrow">{eyebrow}</span>}
        <h3 className="showcase-title">{title}</h3>
        <p className="showcase-text">{text}</p>
        {bullets.length > 0 && (
          <ul className="showcase-bullets">
            {bullets.map((bullet, i) => (
              <li key={i}>{bullet}</li>
            ))}
          </ul>
        )}
      </div>
    </motion.div>
  );
}
